import type { CodeableConcept } from "@curai/js-fhir-tools";
import type * as fhirTypes from "fhir/r4";

export interface ObservationValue {
  value: string;
  display: string;
  friendlyDisplay: string;
  system: string;
}

export enum GroupItemAnswerType {
  CODE = "code",
  MULTI_CODE = "multi-code",
  DATE = "date",
  YES_NO = "yes-no",
  NUMBER = "number",
  PARAGRAPH = "paragraph",
  PRESENCE = "presence",
}

export enum QuickChartOptionClass {
  DENIAL = "denial",
  GENERIC = "generic",
}

export interface QuickChartOption {
  value: ObservationValue;
  optionClass: QuickChartOptionClass;
}

export interface ObservationGroupItem {
  groupItemAnswerType: GroupItemAnswerType;
  observationCode: string;
  observationCodeDisplay: string;
  observationCodeSystem: string;
  observationCodeFriendlyDisplay: string;
  observationValues: ObservationValue[];
  parentCode: string | null;
  parentCodes: string[] | null;
  preloadOptions: boolean;
  documentedObservation: fhirTypes.Observation | null;
  quickChartOptions?: QuickChartOption[];
}

export interface FhirValue {
  valueString?: string | undefined;
  valueInteger?: number | undefined;
  valueBoolean?: boolean | undefined;
  valueCodeableConcept?: Pick<CodeableConcept, "coding" | "text"> | undefined;
  valueDecimal?: number | undefined;
  valueDateTime?: string | undefined;
}

export interface CreateGenericObservationRequest {
  patientId: string;
  category: string;
  code: Pick<CodeableConcept, "coding" | "text">;
  status: string;
  fhirValue?: FhirValue | undefined;
  fhirValues?: FhirValue[] | undefined;
  dataAbsentReason?: string | undefined;
  encounterId?: string | undefined;
}

export interface ReferenceRanges {
  normalRange?: string;
  moderateConcernRange?: string;
  highRiskRange?: string;
}

export enum ReferenceRangeCriticality {
  NORMAL = "NORMAL",
  MODERATE_CONCERN = "MODERATE_CONCERN",
  HIGH_RISK = "HIGH_RISK",
}
